import { NEGOCIOS } from '~/constants/negocios'

export const SITE_URL = 'https://leon.cl'

const SEO_BY_PATH = {
  '/': {
    canonical: '/',
    h1: 'LEÓN Servicio Automotriz',
    title: 'Tu taller automotriz en Chile con garantía total',
    description: 'Encuentra neumáticos, alineación, balanceo y más en tu taller automotriz de confianza. Agenda online, paga en tienda y disfruta la garantía total de LEÓN.',
    keywords: ['servicio automotriz'],
  },
  [`/${NEGOCIOS.NEUMATICOS}`]: {
    canonical: `/${NEGOCIOS.NEUMATICOS}`, h1: 'Neumáticos',
    title: 'Compra y cambia tus neumáticos en LEÓN con instalación y garantía total',
    description: 'Renueva tus neumáticos en LEÓN y disfruta instalación profesional, garantía total y atención experta para tu auto. ¡Agenda online y paga en tienda fácilmente!',
    keywords: ['neumáticos LEÓN'],
  },
  [`/${NEGOCIOS.FRENOS}`]: {
    canonical: `/${NEGOCIOS.FRENOS}`, h1: 'Frenos',
    title: 'Revisión y cambio de frenos en LEÓN con servicio experto',
    description: 'Haz la revisión y cambio de frenos en LEÓN con técnicos expertos y garantía total. Cuida tu seguridad y conduce tranquilo en cada viaje. ¡Agenda tu servicio hoy!',
    keywords: ['frenos LEÓN', 'cambio de frenos', 'revisión de frenos'],
  },
  [`/${NEGOCIOS.ACEITES}`]: {
    canonical: `/${NEGOCIOS.ACEITES}`, h1: 'Cambio de aceite',
    title: 'Cambio de aceite en LEÓN para cuidar el motor de tu auto',
    description: 'Haz tu cambio de aceite en LEÓN con servicio rápido y productos de calidad. Protege el motor y mejora el rendimiento de tu vehículo. ¡Agenda tu cambio hoy!',
    keywords: ['cambio de aceite', 'cambio de aceite LEÓN'],
  },
  [`/${NEGOCIOS.BATERIAS}`]: {
    canonical: `/${NEGOCIOS.BATERIAS}`, h1: 'Cambio de baterías',
    title: 'Cambio de batería con instalación segura y servicio a domicilio',
    description: 'En LEÓN realizamos el cambio de batería con instalación profesional, garantía de hasta 2 años y opción de servicio a domicilio. ¡Agenda tu cambio hoy!',
    keywords: ['cambio de batería', 'baterías a domicilio', 'cambio de baterías a domicilio', 'baterías LEÓN'],
  },
  [`/${NEGOCIOS.AFINAMIENTO}`]: {
    canonical: `/${NEGOCIOS.AFINAMIENTO}`, h1: 'Afinamiento de motor',
    title: 'Afinamiento de motor para mejorar el rendimiento del auto',
    description: 'Realiza el afinamiento de motor en LEÓN y optimiza el rendimiento de tu vehículo con servicio experto y diagnóstico completo. ¡Agenda tu mantenimiento hoy!',
    keywords: ['afinamiento de motor'],
  },
  [`/${NEGOCIOS.AMORTIGUADORES}`]: {
    canonical: `/${NEGOCIOS.AMORTIGUADORES}`, h1: 'Amortiguadores LEÓN',
    title: 'Venta y cambio de amortiguadores con servicio experto',
    description: 'Venta y cambio de amortiguadores en LEÓN con servicio experto, repuestos de calidad y garantía. Mejora seguridad y confort de tu auto. ¡Agenda tu servicio!',
    keywords: ['cambio de amortiguadores', 'venta y cambio de amortiguadores', 'amortiguadores LEÓN'],
  },
  [`/${NEGOCIOS.TRENDELANTERO}`]: {
    canonical: `/${NEGOCIOS.TRENDELANTERO}`, h1: 'Revisión tren delantero',
    title: 'Revisión de tren delantero de tu auto con servicio profesional',
    description: 'Haz la revisión de tren delantero en LEÓN y asegura la estabilidad, dirección y confort de tu vehículo con técnicos especializados. ¡Agenda tu revisión hoy!',
    keywords: ['tren delantero', 'revisión tren delantero'],
  },
  [`/${NEGOCIOS.ALINEACION}`]: {
    canonical: `/${NEGOCIOS.ALINEACION}`, h1: 'Alineación de vehículo',
    title: 'Alineación de vehículo con servicio preciso y rápido',
    description: 'Haz la alineación de tu vehículo en LEÓN y mejora la estabilidad, dirección y seguridad al conducir. Servicio profesional con garantía total. ¡Agenda tu cita!',
    keywords: ['alineación vehículo', 'alineación LEÓN'],
  },
  [`/${NEGOCIOS.BALANCEO}`]: {
    canonical: `/${NEGOCIOS.BALANCEO}`, h1: 'Balanceo de neumáticos',
    title: 'Realiza el balanceo de neumáticos y mejora tu manejo',
    description: 'Realiza el balanceo de tus neumáticos en LEÓN y evita vibraciones, desgaste irregular y pérdida de control. Conduce seguro con un servicio profesional. ¡Agenda!',
    keywords: ['balanceo de neumáticos'],
  },
  [`/${NEGOCIOS.GEOMETRIA}`]: {
    canonical: `/${NEGOCIOS.GEOMETRIA}`, h1: 'Geometría automotriz',
    title: 'Servicio de geometría automotriz para tu vehículo',
    description: 'En LEÓN te ofrecemos el servicio de geometría automotriz para mejorar la estabilidad, dirección y seguridad de tu vehículo. ¡Agenda tu revisión hoy mismo!',
    keywords: ['geometría automotriz'],
  },
  [`/${NEGOCIOS.KILOMETRAJE}`]: {
    canonical: `/${NEGOCIOS.KILOMETRAJE}`, h1: 'Mantención por kilometraje',
    title: 'Conoce nuestro servicio de mantención por kilometraje y evita fallas',
    description: 'En LEÓN te ofrecemos la mantención por kilometraje con revisión completa, cambio de filtros y chequeo de frenos, batería y líquidos. ¡Agenda tu servicio hoy!',
    keywords: ['mantención por kilometraje', 'revisión de kilometraje'],
  },
  [`/${NEGOCIOS.HIGIENIZACION}`]: {
    canonical: `/${NEGOCIOS.HIGIENIZACION}`, h1: 'Higienización y mantención de aire acondicionado',
    title: 'Higienización y mantención de aire acondicionado automotriz',
    description: 'En LEÓN realizamos la higienización y mantención del aire acondicionado de tu vehículo para eliminar olores y cuidar tu salud. ¡Agenda tu servicio con nosotros!',
    keywords: ['mantención aire acondicionado auto'],
  },
  [`/${NEGOCIOS.FLUIDOS}`]: {
    canonical: `/${NEGOCIOS.FLUIDOS}`, h1: 'Cambio de fluidos',
    title: 'Dale nueva vida a tu motor con el cambio de fluidos de tu auto',
    description: 'En LEÓN realizamos el cambio de fluidos de tu auto, incluyendo la limpieza de inyectores, para mantener el motor en óptimo estado. ¡Agenda tu mantención hoy!',
    keywords: ['cambio de fluidos auto', 'limpieza de inyectores'],
  },
  [`/${NEGOCIOS.ACCESORIOS}`]: {
    canonical: `/${NEGOCIOS.ACCESORIOS}`, h1: 'Accesorios para auto',
    title: 'Accesorios para auto con instalación inmediata y servicio express',
    description: 'En LEÓN encuentras accesorios para tu auto con instalación inmediata, garantía y servicio express. Mejora la seguridad y confort de tu vehículo. ¡Visítanos hoy!',
    keywords: ['accesorios para auto'],
  },
  [`/${NEGOCIOS.ELECTRICO}`]: {
    canonical: `/${NEGOCIOS.ELECTRICO}`, h1: 'Servicio eléctrico automotriz',
    title: 'Servicio eléctrico para el correcto funcionamiento del auto',
    description: 'En LEÓN cuentas con un servicio eléctrico automotriz que repara fallas en batería, luces y sistemas electrónicos para mantener tu auto seguro. ¡Agenda ahora!',
    keywords: ['eléctrico automotriz', 'servicio eléctrico automotriz'],
  },
}

export function getMappedSeo(path) {
  return SEO_BY_PATH[path] || null
}

export function useMappedSeo() {
  const route = useRoute()
  const seo = computed(() => getMappedSeo(route.path))

  useSeoMeta({
    title: () => seo.value?.title,
    description: () => seo.value?.description,
    keywords: () => seo.value?.keywords.join(', '),
    ogType: () => seo.value ? 'website' : undefined,
    ogLocale: () => seo.value ? 'es_CL' : undefined,
    ogSiteName: () => seo.value ? 'LEÓN Servicio Automotriz' : undefined,
    ogTitle: () => seo.value?.title,
    ogDescription: () => seo.value?.description,
    ogUrl: () => seo.value ? `${SITE_URL}${seo.value.canonical}` : undefined,
    ogImage: () => seo.value ? `${SITE_URL}/logo-rrss.jpg` : undefined,
    twitterCard: () => seo.value ? 'summary_large_image' : undefined,
    twitterTitle: () => seo.value?.title,
    twitterDescription: () => seo.value?.description,
    twitterImage: () => seo.value ? `${SITE_URL}/logo-rrss.jpg` : undefined,
  })

  return { seo }
}
